// hides private information for SmartLook
const loginFormFieldIds = ['signInName', 'password'];
const forgotPasswordFormFieldIds = ['email'];
const registrationFormFieldIds = [
  'givenName',
  'surname',
  'telephoneNumber',
  'extension_companyName',
  'streetAddress',
  'city',
  'postalCode',
  'combinedLocation',
  'email',
  'VerificationCode',
  'accountType_customer',
  'accountType_vendor',
  'jobTitle',
  'newPassword',
  'reenterPassword',
  'extension_termsOfUseConsentChoice_AgreeToTermsOfUseConsentYes',
  'extension_newsletterConsentChoice_AgreeToNewsletterConsentYes',
];

const setPrivacyAttributes = (elementIdArray) => {
  elementIdArray.forEach((elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.setAttribute('data-sl', 'mask');
    }
  });
};

export const initPrivacy = (): void => {
  setPrivacyAttributes(loginFormFieldIds);
  setPrivacyAttributes(forgotPasswordFormFieldIds);
  setPrivacyAttributes(registrationFormFieldIds);
};
